import React, { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import Layout from "../components/shared/layout";
import InnerPageBanner from "../components/shared/innerPageBanner";
import ImageIcons from "../components/imageComponent/ImageIcons";
import SEO from "../components/shared/seo";
import stdCodes from "../components/utils/data/stdCodes.json";
import { MdOutlineSupportAgent } from "react-icons/md";
import { MdCall } from "react-icons/md";
import { Link } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { IoCheckmarkDoneSharp, IoCloseSharp } from "react-icons/io5";
import CitySelector from "../components/shared/CitySelector";
import axios from "axios";
import { windowScroll } from "../components/utils/windowScroll";

const Plans = () => {
  const navigate = useNavigate();
  const params = useParams();
  console.log("params<<", params)
  const [selectedCity, setSelectedCity] = useState(useParams());
  const [selectedPlan, setSelectedPlan] = useState(null);
  // console.log("select current city", selectedCity);
  const [planDetails, setPlanDetails] = useState({});
   const [activePopup, setActivePopup] = useState(null);
  // console.log(planDetails);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    pincode: "",
    cities: selectedCity?.handle || selectedCity,
    planDetails:planDetails
  });


  const handleCityChange = (newCity) => {
    setSelectedCity(newCity);
    navigate(`/tariff-plans/${newCity}`);
  };
  const [showMessage, setShowMessage] = useState(false);
  const handlePlanSelect = (plan) => {

    console.log("today plan---->", plan);
    // setSelectedPlan();
    setSelectedPlan((prev) => (prev === plan.id ? null : plan.id));

    console.log("selectplan ---------->🔙", selectedPlan)
    setPlanDetails(plan);
    console.log("today plan---setPlanDetail->", planDetails);
  };
  const sliderRef = useRef(null);
  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    // adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          variableWidth: true,
        },
      },
    ],
  };
 
const [errors, setErrors] = useState({});
const [error, setError] = useState("");
 const [,setDisabled] = useState(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
    const trimmedName = name.trim();
    if (!trimmedName) {
      setError("Name cannot be empty or just spaces");
    } else {
      setError("");
      console.log("Submitted:", trimmedName);
      // proceed with trimmedName
    }
  }
// phone number
const handlePhoneInputChange = (e) => {
  const inputValue = e.target.value.trim();
  const numericValue = inputValue.replace(/\D/g, ""); 

  if (numericValue.length <= 10) {
    setFormData((prevState) => ({ ...prevState, phone: numericValue }));
    setErrors((prevState) => ({ ...prevState, phone: false }));
  }
}
// plan
 
const validateForm = () => {
  const newErrors = {};
  if (!formData.name) newErrors.name = "Name is required";
  if (!formData.email) newErrors.email = "Email is required";
  else if (!/\S+@\S+\.\S+/.test(formData.email))
    newErrors.email = "Email is invalid";
  if (!formData.phone) newErrors.phone = "Phone number is required";
  if (!formData.pincode) newErrors.pincode = "pincode is required";
  
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const validRegex = /^(?!.*(\d)\1{9})[6-9]\d{9}$/;

const handleSubmit = async (e) => {
 e.preventDefault()
 
  if (!validateForm()) {
    console.log('Validation Failed');
    return;
  } else if (formData.phone.length < 10) {
    setErrors((prevState) => ({
      ...prevState,
      // phoneNumber: true,
      phone: "Phone number is invalid!",
    }));
    setDisabled(false);
  } else if (!validRegex.test(formData.phone)) {
    setErrors((prevState) => ({
      ...prevState,
      // phone: true,
      phone: "Phone number must be valid !",
    }));
    setDisabled(false);
  }
  else {
    setDisabled(true);
    
    try {
      const selectedPlan = {
        id: planDetails.id,
        name: planDetails.name,
        speed: planDetails.speed,
        data: planDetails.data,
        price: planDetails.price,
        durationMonths: planDetails.durationMonths,
        duration: planDetails.duration,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_URL}user/proscity`,
 
        {
          phone: formData?.phone,
          name: formData?.name,
          email: formData?.email,
          pincode: formData?.pincode,
          city: formData?.cities,
          planDetails: selectedPlan,
        },
        {
          withCredentials: true,
        }
      );
      console.log("Data stored successfully:", response.data);
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
        setFormData({ name: "", email: "", pincode: "", phone: "", cite: "" });
        // setPlanDetails({ planDetails: "" })
        setPlanDetails({ id:"",name:"",   speed:"",data:"", price:"", durationMonths:"",duration:""})
        setSelectedCity({ cite: "" });
      }, 1000,
    setTimeout(()=>{
      navigate("/")
    },2000)
    );
      window.scrollTo(0, 0)
      windowScroll();
      navigate("/thanks");
    } 
    catch (error) {
      console.error("Error submitting form:", error.message);
    }
  }
  };

  return (
    <>
    <SEO title='Affordable Internet Tariff Plans | My Internet Tariff Plans' description='Get affordable internet Tariff Plans With MyInternetZone. Check pricing, compare options, and find the best deal for your home internet needs.' keywords='"internet Tariff Plans, broadband Tariff Plans, My Internet Zone prices, internet Tariff Plans, affordable internet packages, my internet Tariff Plans list"'/>

    <Layout>
      <InnerPageBanner title='Tariff Plans' innerPageBanner={ImageIcons.contactBg} />
     <section className="broadband-plans">
          <div className="container">
            <div className="flex max-lg:flex-col xl:gap-[40px] gap-[20px]">
              <div className="lg:w-[68%]">
                <div className="mb-[30px] flex justify-between items-center gap-[2px]">
                  <h4 className="mb-0 sm:text-[26px] text-[18px] !text-[#000] font-semibold">
                    Select Your City
                  </h4>
                  <CitySelector
                    selectedCity={selectedCity}
                    onCityChange={handleCityChange}
                    cities={cities}
                  />
                </div>

                <Slider
                  ref={sliderRef}
                  {...settings}
                  className="pb-[30px] relative"
                >
                  {plans.map((plan) => (
                    <div
                      key={plan.id}
                      className="relative item select-plans rounded-[5px] max-sm:min-w-[280px] max-sm:max-w-[280px]"
                    >
                      {/* <RiInfinityLine className="xl:text-[28px] text-[18px] absolute xl:top-[20px] top-[16px] xl:right-[25px] right-[10px]" /> */}
                      <div className="xl:p-[25px] p-[20px]">
                        {plan.tag && (
                          <span className="absolute -translate-x-2/4 z-30 -top-[12px] -left-[50%] mx-auto bg-[#f48533] text-white text-[14px] px-[10px] py-[2px] rounded-[5px]">
                            {plan.tag}
                          </span>
                        )}
                        <h3 className="2xl:text-[24px] text-[20px] font-semibold mb-[15px] text-[#f48533] text-center">
                          {plan.speed}
                        </h3>

                        <div className="text-center bg-[#f7f7f7] my-[10px] py-[5px] rounded-[5px] text-[20px] font-semibold">
                          RS.
                          <span className="xl:text-[45px] md:text-[36px] sm:text-[32px] text-[28px] font-bold text-[#000]">
                            {plan.price}
                          </span>
                        </div>
                        <ul className="grid gap-[8px] pt-[5px]">
                          <li className="text-center text-[15px]">
                            <strong className="whitespace-nowrap font-medium">
                              Duration: </strong>
                            {plan.duration}
                          </li>
                          <li className="flex justify-center gap-[6px] text-[15px] items-center">
                            <strong className="whitespace-nowrap font-medium">Free OTT: </strong>
                            <ul className='flex items-center'>
                              {plan.showLogos?.slice(0, 4).map((logo, index) => (
                                <li
                                  key={index}
                                  className={`w-[35px] h-[35px] border border-[#fff] rounded-full overflow-hidden ${index !== 0 ? '-ml-[12px]' : ''}`}
                                >
                                  <img className='w-full h-full object-cover' src={logo} alt='OTT logo' />
                                </li>
                              ))}

                              {plan.logos?.length > 4 && (
                                <div className="relative z-30">
                                  <li
                                    onClick={() => setActivePopup(plan.id)}
                                    className='w-[35px] h-[35px] border border-[#7a7a7a] rounded-full overflow-hidden -ml-[12px] flex items-center justify-center bg-white cursor-pointer text-[13px]'
                                  >
                                    +{plan.logos.length - 4}
                                  </li>
                                </div>
                              )}
                            </ul>
                          </li>
                        </ul>
                      </div>
                      <input
                        type='checkbox'
                        id={plan.id}
                        checked={selectedPlan === plan.id}
                        onChange={() => handlePlanSelect(plan)}
                        className='absolute top-0 left-0 w-full h-full appearance-none cursor-pointer'
                      />
                      <div className='bg-[#f7f7f7] text-center text-[15px] py-[6px] text-select-plans rounded-b-[5px]'>
                        Select Plan
                      </div>
                    </div>
                  ))}
                </Slider>

                {activePopup && (
                <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[9999999999]" 
                     onClick={() => setActivePopup(null)}>
                  <div className="bg-white md:p-[40px] p-[30px] rounded-xl shadow-lg max-w-[700px] mx-[15px] text-center relative" 
                       onClick={(e) => e.stopPropagation()}>
                    <ul className='grid md:grid-cols-7 sm:grid-cols-5 grid-cols-5 flex-wrap sm:gap-[10px] gap-[5px] justify-center items-center overflow-y-auto'>
                      {plans.find(p => p.id === activePopup)?.logos.map((logo, index) => (
                        <li key={index} className='inline-block lg:max-w-[80px] sm:max-w-[70px] max-w-[50px] bg-[#f7f7f7]'>
                          <img src={logo} alt={`OTT logo ${index + 1}`} className="w-full h-auto" />
                        </li>
                      ))}
                    </ul>
                    <button className="absolute top-0 right-0 bg-[#e27629] text-white duration-500 h-[30px] w-[30px] flex justify-center items-center rounded hover:bg-[#f48533]"
                            onClick={() => setActivePopup(null)}>
                      <IoCloseSharp />
                    </button>
                  </div>
                </div>
              )}              

                <div className="flex justify-center gap-[210px]">
                  <button
                    type="button"
                    className="relative z-10 h-[40px] w-[40px] border border-[#000] duration-500 hover:bg-[#000] hover:text-[#ffff] cursor-pointer rounded-[10px] flex justify-center items-center text-[24px]"
                    onClick={() => sliderRef.current.slickPrev()}
                  >
                    <IoIosArrowBack />
                  </button>
                  <button
                    type="button"
                    className="relative z-10 h-[40px] w-[40px] border border-[#000] duration-500 hover:bg-[#000] hover:text-[#ffff] cursor-pointer rounded-[10px] flex justify-center items-center text-[24px]"
                    onClick={() => sliderRef.current.slickNext()}
                  >
                    <IoIosArrowForward />
                  </button>
                </div>

                <ul className="mt-[30px] text-gray-700">
                  {details.map((detail, index) => (
                    <li
                      key={index}
                      className="mb-[6px] text-[16px] relative pl-[25px]"
                    >
                      <IoCheckmarkDoneSharp className="text-[17px] inline-block text-[#f48533] absolute left-0 top-[5px]" />
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="lg:w-[32%]">
                <h2 className="xl:text-[26px] md:text-[24px] text-[22px] px-[10px] text-center bg-[#f68140] text-white py-[12px] -mb-[5px] rounded-t-[5px] relative">
                  Get Same Day Installation!
                </h2>

                <form
                  className="grid grid-cols-1 gap-[12px] w-full ml-auto shadow-[0px_0px_40px_0px_rgba(0,0,0,0.1)] bg-[#fffffff7] xl:p-[30px] md:p-[25px] p-[20px] rounded-[5px]"
                >
                  <p className="text-[16px] mb-0 text-center px-[10px]">
                    Just enter your details to check availability
                  </p>

                  <input
                    
                    value={formData.name}
                    // onChange={(e) =>
                    //   setFormData({ ...formData, name: e.target.value })
                    // }nd
                    onChange={handleInputChange}
                    id="inputName"
                    name="name"
                    maxLength={25}
                    placeholder="Enter Name"
                    className="text-[16px] w-full h-[45px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                  />
                  {errors.name && <div style={{color:"red",fontSize:14}}>{errors.name}</div>}
                  <input
                    
                    value={formData.email}
                    // onChange={(e) =>
                    //   setFormData({ ...formData, email: e.target.value })
                    // }
                    onChange={handleInputChange}
                    placeholder="example@gmail.com"
                    id="inputEmail"
                    name="email"
                    className="text-[16px] w-full h-[45px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                  />
               {errors.email && <div style={{color:"red",fontSize:14}}>{errors.email}</div>}

                  <div className="flex">
                    <select
                      name="stdCode"
                      value={formData.stdCode}

                      onChange={handleInputChange}
                      className="text-[16px] h-[45px] px-[10px] min-w-[115px] !border-r-0 rounded-r-none border border-[#f7dfcd] bg-[#f4853308] rounded-[4px] focus:outline-none"
                      defaultValue="+91"
                    >
                      {stdCodes.map((item, i) => (
                        <option
                          key={i}
                          value={item.dial_code}
                          className="h-[20px] text-[16px]"
                        >
                          {item.dial_code} ({item.code})
                        </option>
                      ))}
                    </select>
                    <input
                      value={formData.phone}
                      // onChange={(e) =>
                      //   setFormData({ ...formData, phone: e.target.value })
                      // }
                      onChange={handlePhoneInputChange}
                      id="inputPhone"
                      name="phone"
                      type="number"
                      placeholder="Enter Phone Number"
                      maxLength={10}
                      className="text-[16px] w-full rounded-l-none h-[45px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                    />
                  </div>
                     {errors.phone && <div style={{color:"red",fontSize:14}}>{errors.phone}</div>}

                  <input
                    
                    value={formData.pincode}
                    // onChange={(e) =>
                    //   setFormData({ ...formData, pincode: e.target.value })
                    // }
                    onChange={handleInputChange}
                    id="PinCode"
                    name="pincode"
                    type="text" 
                    maxlength="6" 
                    pattern="\d{1,6}" 
                    title="Enter up to 6 digits"
                    placeholder="Pin Code"
                    className="text-[16px] w-full h-[45px] border border-[#f7dfcd] bg-[#f4853308] px-[15px] rounded-[5px] focus:outline-none focus:border-[#f48533] focus:bg-[#fbf2ee]"
                  />
                   {errors.pincode && <div style={{color:"red",fontSize:14}}>{errors.pincode}</div>}

                  <button

                    className="px-[45px] mt-[5px] py-[11px] duration-500 font-medium text-[#fff] bg-[#f48533] rounded-[10px] hover:bg-[#000] ease inline-block"
                   
                       onClick={handleSubmit}
                  >
                    Submit
                  </button>

                  <div className="text-[#008000] text-center px-[15px] py-[5px] text-[18px]">
                    {showMessage && (
                      <div className="toast toast-top toast-center">
                        <div className="alert alert-success">
                          <span>Message sent successfully.</span>
                        </div>
                      </div>
                    )}
                  </div>
                </form>

                <div className="grid grid-cols-1 gap-[10px] w-full ml-auto shadow-[0px_0px_40px_0px_rgba(0,0,0,0.1)] bg-[#fffffff7] xl:p-[30px] md:p-[25px] p-[20px] rounded-[5px] mt-[15px]">
                  <h5 className="mb-0">Any Questions?</h5>
                  <p className="mb-[2px] text-[#979797] text-[16px]">
                    Contact us, we are a call away
                  </p>

                  <Link
                    to="tel:+919464001234"
                    className="flex gap-[10px] items-center text-[16px] hover:text-[#F48533] duration-500"
                  >
                    <MdCall className="text-[25px] min-w-[25px]" />
                    +91 9464001234
                  </Link>

                  <span className="flex gap-[10px] items-center text-[16px]">
                    <MdOutlineSupportAgent className="text-[25px] min-w-[25px]" />
                    24×7 Instant Support
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

    </Layout>
    </>
  )
}

const cities = [
  "harchowal",
  "jalandhar",
  "qadian",
  "dharamkot",
  "salodi-khanna",
  "mallanwala",
  "bhadson",
  "bhikhi",
  "rupnagar",
  "nabha",
  "cheema",
  "maloud",
  "malout",
  "nurpur",
  "samana",
  "bareta",
  "boha",
  "budhlada",
  "kullewal",
  "samrala",
  "kapurthala",
  "rawal",
  "moonak",
  "mansa",
  "raman-mandi",
  "khamano",
  "jandiala",
  "rajpura",
  "talwandi-bhai",
  "talwandi-sabo",
  "pathankot",
  "kiratpur-sahib",
  "zira",
  "derrabassi",
  "bhunerheri",
  "kala-afgana",
  "maur-mandi",
  "ludhiana",
  "gidderbaha",
  "ferozepur-cantt",
  "amritsar",
  "kot-ise-khan",
  "badali",
  "jalandhar-2",
  "sanour",
  "zirakpur",
  "hiran",
  "sherpur",
  "behrampur",
  "sirhind",
  "raikot",
  "daulatpura",
  "mudki",
  "fazilka",
  "bharatgarh",
  "nabha-sahib",
  "channo",
  "ferozepur",
  "badmajra",
  "devigarh",
  "patran",
  "patiala",
  "longowal",
  "mohali",
  "panchkula",
  "chandigarh",
  "badali-ala-singh",
  "sarthali",
  "nurpur-bedi",
  "kanech",
  "ambala",
  "kalarehri",
  "jain-pura",
  "barwala",
  "hisar",
  "kaithal",
  "raipur-rani",
  "panipat",
  "ambala-cantt",
  "ahlisadar",
  "kaliana",
  "fatehabad",
  "gurugram",
  "naraingarh",
  "shahzadpur",
  "ganaur",
  "bhattu-mandi",
  "kakkar-heri",
  "chautala",
  "karnal",
  "balsamand",
  "pundri",
  "headon",
  "meerut",
  "sadarpur",
  "gaziabad",
  "noida",
  "nagrota-bagwan",
  "nadaun",
  "sullah",
  "mandi",
  "jogindernagar",
  "chauntra",
  "palampur",
  "mumbai",
  "gujarat",
  "delhi",
];

const details = [
  'Same Day Installation.',
  'Zero Installation/ Activation charges.',
  'Prices shown above exclude GST of 18%.',
  'Free dual band wifi router for use'
]

const plans = [
  {
    id: 'plan1',
    name: 'IPTV FTA',
    speed: '50 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '399',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Value Plan',
    showLogos: [ ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.dangalPlay, ImageIcons.chanaJor],
     logos: [
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.fancode,
      ImageIcons.dangalPlay,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.shucaeFilms,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.travelxp,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan4',
    name: 'IPTV SILVER HD',
    speed: '200 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '699',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Best Seller plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.discovery,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan2',
    name: 'IPTV BRONZE',
    speed: '100 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '499',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Popular Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.chaupal],
    logos: [
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.rajTv,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.dangalPlay,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.shucaeFilms,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.tarangplus,
      ImageIcons.travelxp,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan5',
    name: 'IPTV GOLD HD',
    speed: '200 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '799',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Premium Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan6',
    name: 'IPTV GOLD PLUS HD',
    speed: '200 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '999',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Elite Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan7',
    name: 'IPTV GOLD PLUS HD',
    speed: '300 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '1299',
    durationMonths: '6+1 Months',
    duration: 'Pay For 6 Months & Get 1 Month Free',
    offer: 'Free OTT',
    tag: 'Fast Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan3',
    name: 'IPTV SILVER HD',
    speed: '150 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '599',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Standard Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan8',
    name: 'IPTV PLATINUM HD',
    speed: '300 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '1499',
    durationMonths: '12+2 Months',
    duration: 'Pay For 12 Months & Get 2 Month Free',
    offer: 'Free OTT + Router',
    tag: 'Top Choice',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan9',
    name: 'IPTV PLATINUM HD',
    speed: '500 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '1999',
    durationMonths: '12+2 Months',
    duration: 'Pay For 12 Months & Get 2 Month Free',
    offer: 'Free OTT + Router',
    tag: 'Ultra Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  }
]

export default Plans